module.exports = __webpack_public_path__ + "static/img-hexapod-desktop@2x-b137e15372987ae10179cd580b235e4a.jpg";